import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Atlas visual del 5 moderno',
  value: '$6.500'
}, {
  title: '30 ejercicios específicos para mediocampistas defensivos',
  value: '$8.900'
}, {
  title: 'Plan de entrenamiento físico de 8 semanas',
  value: '$12.000'
}, {
  title: 'Planilla de análisis de partidos',
  value: '$4.500'
}, {
  title: 'Guía de estudio de mediocampistas profesionales',
  value: '$5.900'
}];
export function Bonuses() {
  return <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-12">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-[100px] pointer-events-none" data-id="element-13"></div>

      <div className="max-w-5xl mx-auto" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <div className="inline-block bg-brand-greenSoft text-brand-green font-bold px-4 py-1 rounded-full mb-4 animate-pulse border border-brand-green/30" data-id="element-16">
            SOLO HOY
          </div>
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-brand-text" data-id="element-17">
            BONOS <span className="text-brand-green" data-id="element-18">GRATIS</span> POR HOY
          </h2>
          <p className="text-xl text-brand-muted mt-4" data-id="element-19">
            Estos 5 bonos son{' '}
            <strong className="text-brand-text" data-id="element-20">100% GRATIS</strong> si compras
            hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-21">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`bg-white border border-brand-green/30 rounded-xl p-6 flex items-start gap-4 relative overflow-hidden shadow-sm hover:shadow-md transition-shadow ${index === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-22">
              <div className="absolute top-0 right-0 bg-brand-green text-white font-bold text-xs px-3 py-1 rounded-bl-lg" data-id="element-23">
                Valor:{' '}
                <span className="line-through opacity-80" data-id="element-24">{bonus.value}</span>{' '}
                GRATIS
              </div>
              <div className="flex-shrink-0 w-12 h-12 rounded-full bg-brand-greenSoft flex items-center justify-center text-brand-green mt-2" data-id="element-25">
                <Gift className="w-6 h-6" data-id="element-26" />
              </div>
              <div className="pt-2 pr-16" data-id="element-27">
                <h3 className="text-lg font-bold text-brand-text leading-tight" data-id="element-28">
                  <span className="text-brand-green mr-1" data-id="element-29">
                    Bono {index + 1} —
                  </span>
                  {bonus.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}